import React, { useState } from 'react'
import { Typography, TextField, Grid, FormControl, InputLabel, Select, MenuItem } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { Controller, useFormContext } from 'react-hook-form'
import { map } from 'lodash'
import PhoneNumber from './phoneNumber'

const UserInfo = () => {
  const { t } = useTranslation('translations')
  const { control, errors } = useFormContext()

  const [genderValues] = useState([
    {
      value: 'M',
      label: t('booking.userInfo.gender.male'),
    },
    {
      value: 'F',
      label: t('booking.userInfo.gender.female'),
    },
    {
      value: 'notSpecified',
      label: t('booking.userInfo.gender.notSpecified'),
    },
  ])
  const [workValues] = useState([
    {
      value: 'italianStudent',
      label: t('booking.userInfo.work.italianStudent'),
    },
    {
      value: 'foreignStudent',
      label: t('booking.userInfo.work.foreignStudent'),
    },
    {
      value: 'selfEmployed',
      label: t('booking.userInfo.work.selfEmployed'),
    },
    {
      value: 'employee',
      label: t('booking.userInfo.work.employee'),
    },
  ])
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h4">{t('booking.userInfo.title')}</Typography>
        </Grid>
        <Grid item xs={12} lg={10}>
          <Typography variant="body1">{t('booking.userInfo.age.title')}</Typography>
          <Controller
            name="tenant_age"
            as={
              <TextField
                fullWidth
                type="number"
                min="18"
                error={errors.tenant_age}
                variant="outlined"
                label={t('booking.userInfo.age.placeholder')}
              />
            }
          />
        </Grid>
        <Grid item xs={12} lg={10}>
          <Typography variant="body1">{t('booking.userInfo.gender.title')}</Typography>
          <FormControl fullWidth variant="outlined" error={errors.tenant_gender}>
            <InputLabel name="gender">{t('booking.userInfo.gender.placeholder')}</InputLabel>
            <Controller
              name="tenant_gender"
              control={control}
              defaultValue=""
              rules={{ required: true }}
              as={
                <Select label={t('booking.userInfo.gender.placeholder')}>
                  {map(genderValues, (value) => (
                    <MenuItem key={value.value} value={value.value}>
                      {value.label}
                    </MenuItem>
                  ))}
                </Select>
              }
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} lg={10}>
          <Typography variant="body1">{t('booking.userInfo.work.title')}</Typography>
          <FormControl fullWidth variant="outlined" error={errors.tenant_reason}>
            <InputLabel name="tenant_reason">{t('booking.userInfo.work.placeholder')}</InputLabel>
            <Controller
              name="tenant_reason"
              control={control}
              defaultValue=""
              rules={{ required: true }}
              as={
                <Select label={t('booking.userInfo.work.placeholder')}>
                  {map(workValues, (value) => (
                    <MenuItem key={value.value} value={value.value}>
                      {value.label}
                    </MenuItem>
                  ))}
                </Select>
              }
            />
          </FormControl>
        </Grid>
        <PhoneNumber phoneVerification={false} numberDisabled />
        <Grid item xs={12} lg={10}>
          <Typography variant="body1">{t('booking.userInfo.message.title')}</Typography>
          <Controller
            name="tenant_comment"
            as={
              <TextField
                variant="outlined"
                placeholder={t('booking.userInfo.message.placeholder')}
                rows={4}
                error={errors.tenant_comment}
                fullWidth
                multiline
              />
            }
          />
        </Grid>
      </Grid>
    </>
  )
}

export default UserInfo
